import { useFirestore, useFirestoreCollectionData } from 'reactfire'
import {
  collection,
  documentId,
  DocumentData,
  query,
  where,
} from 'firebase/firestore'
import {
  resolveTaxOfficeNumber,
  taxOfficeLookupNumbers,
} from './shared/taxOfficeNumber'
import { FederalState } from './shared/models/Company'

export const useTaxOffice = ({
  county,
  taxId,
  override,
}: {
  county?: FederalState | null
  taxId?: string | null
  override?: string | null
}): { taxOfficeNumber: string | null; taxOffice: DocumentData | null } => {
  const firestore = useFirestore()

  const lookupNumbers = taxOfficeLookupNumbers(county, taxId, override)

  const { data: candidates } = useFirestoreCollectionData(
    query(
      collection(firestore, 'configs', 'authorities', 'tax-offices'),
      where(documentId(), 'in', lookupNumbers.length ? lookupNumbers : ['none'])
    ),
    { idField: 'uid' }
  )

  const found = new Map(
    (candidates ?? []).map((office) => [office.uid, office])
  )

  const taxOfficeNumber = resolveTaxOfficeNumber({
    county,
    taxId,
    override,
    exists: (number) => found.has(number),
  })

  return {
    taxOfficeNumber,
    taxOffice: taxOfficeNumber ? (found.get(taxOfficeNumber) ?? null) : null,
  }
}
